export const regex = {
  name: /^\w{5,20}$/,
  pwd: /^[\w|\W]{6,16}$/,
  realName: /^[\u4e00-\u9fa5a-zA-Z0-9]{2,20}$/,
  sceneName: /^[\u4e00-\u9fa5]{2,7}$/,
  email: /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/,
  mobile: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
  mobileSecret: /(\d{3})\d{4}(\d{4})/,
  idCard: /(\d{6})\d{8}(\d{3}[\d|X|x]{1})/,
  phone: /^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?$/,
  phoneAndMobile: /^((0[0-9]{2,3}-?)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?)|(1[3|4|5|6|7|8|9][0-9]\d{8})$/,
  verifyCode: /^\d{6}$/,
  postCode: /^[1-9][0-9]{5}$/,
  licensePlateNum: /^[\u4e00-\u9fa5][A-Za-z][0-9A-Za-z]{5,6}$/,
  licenseNum: /^[A-Za-z][0-9A-Za-z]{5,6}$/,
  frameNum: /^[0-9a-zA-Z]{17}$/,
  engineNo: /^[0-9a-zA-Z-]{6,20}$/,
  seatNum: /^[1-9][0-9]{0,2}$/,
  number: /^\d{1,10}$/,
  floatNumber: /^\d{1,10}(\.\d{0,2})?$/,
  floatNumber2: /^(-)?\d{1,10}(\.\d{0,2})?$/,
  floatNumber4: /^\d{1,4}(\.\d{0,4})?$/,
  floatNumber5: /^\d{1,15}(\.\d{0,4})?$/,
  floatNumber6: /^\d{1,8}(\.\d{0,2})?$/,
  floatNumber7: /^(-)?\d{1,10}(\.\d{0,4})?$/,
  trim: /(^\s*)|(\s*$)/g,
  html: /<[^>]+>/g,
  htmlspace: /(<[^>]+>)|(&nbsp;)|\s/g,
  // password: /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,16}$/
  password: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,16}$/, // 包含大小写字母、数字、特殊字符至少3个组合大于8个字符

  number0_100: /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/,
  number0_100_4: /^(100)$|^((\d|[1-9]\d)(\.\d{1,4})?)$/,
  // url: /^((https|http)?:\/\/)?[^\s]+/,
  url: /^((https?|ftp|file):\/\/)?([\da-z\\.-]+)\.([a-z\\.]{2,6})([\\/\w\\.-]*)*\/?$/,

  password0: /^[\w\W]{8,}$/,
  password1: /^(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/,
  password2: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  speicalSymbols: /[`~!@#$%^&*()_\-+=<>?:"{}|,.\\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/i,
  documentName: /^[\u4e00-\u9fa5a-zA-Z0-9]{1,20}$/,
  documentType: /^[\u4e00-\u9fa5a-zA-Z0-9]{1,10}$/,
  documentRemark: /^[\u4e00-\u9fa5a-zA-Z0-9]{1,50}$/,
  positionName: /^[\u4e00-\u9fa5a-zA-Z]{0,12}$/, // 匹配岗位名称
  vehicleLicenceCode: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
}



// WEBPACK FOOTER //
// ./src/utils/regex.js